import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ContabilizacaoIirgd } from './types';

export const INITIAL_STATE: ContabilizacaoIirgd = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ContabilizacaoIirgd {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONTABILIZACAO_IIRGD_REQUEST: {
				break;
			}
			case Types.CONTABILIZACAO_IIRGD_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONTABILIZACAO_IIRGD_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.CONTABILIZACAO_IIRGD_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
